import TickCircle from '@/app/_components/ui/icons/TickCircle.svg';
import CopySmall from '@/app/_components/ui/icons/CopySmall.svg';
import React from 'react';
import { useRef, useState } from 'react';

export default function CouponTicket({ coupon }) {
  const couponCode = useRef(null);
  const [copySuccess, setCopySuccess] = useState('');
  const copyToClipboard = async (e) => {
    const copyMe = couponCode.current.innerText;
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess('کپی شد');
    } catch (err) {
      setCopySuccess('');
    }
  };
  return (
    <div className="couponCard relative rounded-md bg-chablis first:mt-0 mt-2 ">
      <div className="couponContent text-sm px-4 py-2 flex justify-between">
        <div className="">
          <div className="text-xs text-Outrageous-Orange ">
            <span className="pl-1">
              {coupon.type == 'percentage'
                ? coupon.value
                : coupon.value.toLocaleString('fa-IR')}
            </span>
            {coupon.type == 'percentage' ? 'درصد' : 'تومان'}
            <span className="pr-1">تخفیف</span>
          </div>
          <div className="text-tiny ">{coupon?.title}</div>
        </div>
        <div className="border-r border-dashed border-white w-1"></div>
        <div className=" flex items-center justify-center min-w-[100px]">
          <div
            className="inline bg-white min-h-[32px] px-2 py-1 flex items-center  rounded-md text-tiny font-bold cursor-pointer  text-Outrageous-Orange"
            onClick={copyToClipboard}
          >
            <span className="pl-1" ref={couponCode}>
              {coupon.code}
            </span>
            {copySuccess ? (
              <TickCircle fill="#FF5C39" />
            ) : (
              <CopySmall fill="#FF5C39" />
            )}
          </div>
        </div>
      </div>

      <div className="circle1"></div>
      <div className="circle2"></div>
    </div>
  );
}
